module.exports = __webpack_public_path__ + "front/img/register-bg.5e07b0c1.png";